import { toast } from 'react-toastify'
import { HubConnectionBuilder } from '@aspnet/signalr'
import { actionCreators } from 'store/modules/notifications'
import { constants } from 'consts'
import { getAccessToken } from 'utils/accessToken'
import { localize } from 'store/modules/localization'

const startSignalRConnection = (connection, store) => {
  connection.start()
    .then(() => {
      console.log('SignalR connection established...')
    })
    .catch(err => {
      console.error('SignalR connection failed. ' + err.toString())
      setTimeout(() => startSignalRConnection(connection, store), 5000)
    })
}

const updateBackgroundAction = (dispatch, payload) => {
  if (dispatch) { dispatch(actionCreators.updateBackgroundAction(JSON.parse(payload))) } else { console.log('dispatch is not defined') }
}

const refreshNeeded = (dispatch, payload) => {
  if (dispatch) { dispatch(actionCreators.refreshNeeded(payload)) } else { console.log('dispatch is not defined') }
}

const showToast = (store, type = 'info', text) => {
  if (text && store) {
    toast[type](localize(store.getState().localization, text))
  }
}

export const startSignalR = (store) => {
  const connection = new HubConnectionBuilder()
    .withUrl(`${constants.API_BASE_URI}/notifications`, { accessTokenFactory: () => getAccessToken() })
    .build()

  connection.on('UpdateBackgroundAction', (payload) => updateBackgroundAction(store.dispatch, payload))
  connection.on('ShowToast', (type, text) => showToast(store, type, text))
  connection.on('RefreshNeeded', (type) => refreshNeeded(store.dispatch, type))

  connection.onclose(() => setTimeout(() => startSignalRConnection(connection, store), 5000))
  startSignalRConnection(connection, store)
}
